import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinCuti = createAsyncThunk(
    "getMinCuti",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"master/cuti/min",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getCuti = createAsyncThunk(
    "cuti/get",
    async ({start, count, search}, thunkAPI) => {

        const config = {
            headers: {'Authorization': `Bearer ` + user.Token},
            params: {"start": start, "count": count, "search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+"master/cuti",
                config
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertCuti = createAsyncThunk(
    "cuti/insert",
    async (obj, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"master/cuti",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateCuti = createAsyncThunk(
    "cuti/update",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.put(
                process.env.REACT_APP_API_URL+"master/cuti",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",

};

export const mastercutiSlice = createSlice({
    name: "mastercuti",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinCuti.fulfilled]: (state, {payload}) => {

            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinCuti.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinCuti.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getCuti.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;

            return state;
        },
        [getCuti.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCuti.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertCuti.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertCuti.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertCuti.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateCuti.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateCuti.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateCuti.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const cutiSelector = (state) => state.mastercuti;
